import { render } from "./NotificationNasaTelemetry.vue?vue&type=template&id=5ea66cf1"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__